export default __webpack_public_path__ + "static/media/mainImage.38eed30d.png";